<template>
  <v-layout :class="padding" >
    <v-flex>
      <input
        type="file"
        ref="selectFile"
        name="file"
        :multiple="multiple"
        :accept="createAcceptableAttrString(extensions)"
        @change="onFilePicked"
      />
      <e-file
        v-if="directUpload && fileWasPicked"
        :fileName="getFileName(file)"
        @clearFile="onFileCleared"
        @uploadFile="onFileUpload(file)"
      />
      <v-btn
        v-else
        @click="onPickFile"
        :disabled="disabled"
        :color="btnAppearance.color"
        :raised="btnAppearance.raised"
      >
         {{ btnAppearance.text }}
          <v-icon v-if="iconVisible" right>
            file_upload
          </v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapActions } from 'vuex'
  import { prop, not, or, map, join, any, equals } from 'ramda'
  import EFile from './fileToUpload'
  import { api } from '@/modules/api'

  const getFileName = prop('name')

  export default {
    components: {
      EFile
    },
    props: {
      btnAppearance: {
        type: Object,
        default: () => {
          return {
            text: 'Upload File',
            color: '',
            raised: true,
            hideIcon: false
          }
        }
      },
      isShowErrorMessage: {
        type: Boolean,
        default: false
      },
      showUploadBtn: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      extensions: {
        type: Array,
        required: true
      },
      multiple: {
        type: Boolean,
        required: false,
        default: false
      },
      directUpload: {
        type: Boolean,
        required: false,
        default: true
      },
      padding: {
        type: String,
        required: false,
        default: "pa-5"
      },
      url: {
        type: String,
        default: api.invitationMultiply.getMultiplyBlitzLink()
      },
      method: {
        type: String,
        default: 'post'
      }
    },
    computed: {
      iconVisible () {
        return not(this.btnAppearance.hideIcon)
      },
      // isShowUploadBtn () {
      //   return !this.directUpload && !this.fileWasPicked && this.showUploadBtn
      // }
    },
    data () {
      return (
        {
          customContentTypes: {
            csv: 'text/plain',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            pdf: 'application/pdf'
          },
          fileWasPicked: false,
          file: null,
          formats: []
        }
      )
    },
    methods: {
      ...mapActions(['uploadFile', 'showResultErrorMessage']),
      getFileName,
      onPickFile () {
        this.$refs.selectFile.value = null
        this.$refs.selectFile.click()
      },
      onFileCleared () {
        this.fileWasPicked = false
        this.file = null
      },
      onFilePicked (e) {
        const file = this.multiple ? (e.target.files || e.dataTransfer.files) : (e.target.files || e.dataTransfer.files)[0]
        if (file) {
          this.fileWasPicked = true
          this.$emit('filePicked', file)
          if(this.directUpload) this.file = file
        } else {
          this.showResultErrorMessage(`Couldn't pick a file.`)
        }
      },
      async onFileUpload (file) {
        const extension = this.getFileExtension(this.getFileName(file))

        if (!this.checkExtension(extension)) {
          let extensions = join(', ',this.extensions)
          this.showResultErrorMessage(`Please upload file which has one of the following extensions: ${extensions}`)
          this.resetFile()

          return
        }

        try {
          const result = await this.uploadFile({
            method: this.method,
            route: 'listing',
            file,
            url: this.url,
            headers: {'Content-type': this.useCustomContentType(extension)}, // needed in case of custom headers
            isShowErrorMessage: this.isShowErrorMessage
          })
          if (result && result.status === 204) {
            this.resetFile()
          }
        } catch (e) {
          console.log(e)
          this.showResultErrorMessage(`Something went wrong. Please, try again later.`)
        }
      },
      createAcceptableAttrString (formatsArr) {
        // A little helper which lets you add formats like both as 'csv' and '.csv'.
        // Returns undefined if format was set incorrectly.
        return formatsArr
          .map(format => {
            if ( or(format.indexOf('.') === 0, format.includes('/')) ) {
              this.formats = format
              return format
            } else if (!format.includes('.')) {
              this.formats = `.${format}`
              return `.${format}`
            }
            return
          })
          .join(', ')
          .trim()
      },
      useCustomContentType (extension) {
        const correspondingExtension = Object.keys(this.customContentTypes)
          .find(key => key === extension)

        return this.customContentTypes[correspondingExtension] || 'application/json'
      },
      getFileExtension (fileName) {
        // an array which tells you the extension, index where a 'stop. symbol was
        // found and an inpunt
        const extension =  (/[.]/.exec(fileName))
          ? /[^.]+$/.exec(fileName)
          : undefined

        return extension[0] // the file extension itself
      },
      checkExtension (ext) {
        let fn = extension => {
          let regEx = new RegExp(ext, 'g')
          return Boolean(extension.match(regEx))
        }
        return any(equals(true))(map(fn, this.extensions))
      },
      resetFile () {
        this.file = null
        this.fileWasPicked = false
      }
    }
  }
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Upload/index.vue